<template>
  <TaskForm :task="$store.state.tasks.task" :onSubmit="submit"></TaskForm>
</template>

<script>
import TaskForm from './Task-Form.vue';
import { busEvent } from '../../main';
import { mapMutations } from 'vuex';

export default {
  name: 'create-task',
  components: {
    TaskForm,
  },

  created() {
    this.resetTask();
  },

  methods: {
    ...mapMutations('tasks', ['resetTask']),
    submit() {
      this.$store.dispatch('tasks/createTask', this.$store.state.tasks.task).then(() => {
        busEvent.$emit('succesPopupCreated', 'Taskul a fost creat');
        this.$router.push({ path: '/tasks' });
      });
    },
  },
};
</script>
